import React from 'react'
import { TITLE, DETAIL_ONE, DETAIL_TWO, DETAIL_THREE, DETAIL_FOUR, DETAIL_FIVE, DETAIL_SIX } from "../constant/termsAndCondition";
import { IReduxStateData } from '../interfaces/redux';
import { useSelector } from 'react-redux';

export default function TermsAndCondition() {
    const globalState = useSelector((state: IReduxStateData) => state);
    return (
        <div className="container pt-5 pb-5">
            <div className="pt-2" dangerouslySetInnerHTML={{ __html: TITLE[globalState?.selectedLang || ""] }} />

            <div className="pt-2" dangerouslySetInnerHTML={{ __html: DETAIL_ONE[globalState?.selectedLang || ""] }} />

            <div className="pt-2" dangerouslySetInnerHTML={{ __html: DETAIL_TWO[globalState?.selectedLang || ""] }} />

            <div className="pt-2" dangerouslySetInnerHTML={{ __html: DETAIL_THREE[globalState?.selectedLang || ""] }} />

            <div className="pt-2" dangerouslySetInnerHTML={{ __html: DETAIL_FOUR[globalState?.selectedLang || ""] }} />

            <div className="pt-2" dangerouslySetInnerHTML={{ __html: DETAIL_FIVE[globalState?.selectedLang || ""] }} />

            <div className="pt-2" dangerouslySetInnerHTML={{ __html: DETAIL_SIX[globalState?.selectedLang || ""] }} />
        </div>
    )
}
